import { render, staticRenderFns } from "./ConfigurarPantallaServipag.vue?vue&type=template&id=2eb2ce9a&"
import script from "./ConfigurarPantallaServipag.vue?vue&type=script&lang=ts&"
export * from "./ConfigurarPantallaServipag.vue?vue&type=script&lang=ts&"
import style0 from "./ConfigurarPantallaServipag.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('2eb2ce9a', component.options)
    } else {
      api.reload('2eb2ce9a', component.options)
    }
    module.hot.accept("./ConfigurarPantallaServipag.vue?vue&type=template&id=2eb2ce9a&", function () {
      api.rerender('2eb2ce9a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Conecta/MantenedorServipag/ConfigurarPantallaServipag.vue"
export default component.exports